import axios from "axios";
import { useEffect, useState } from "react";

declare const window: any;

interface IAppConfig {
  PartnerApiUrl: string;

  Environment: string;
  AppBase: string;
  AppVersion: string;
}

let cachedAppConfig: IAppConfig | undefined = undefined;

export let appConfig: IAppConfig = {} as IAppConfig;

export function getAppConfig(): IAppConfig {
  return cachedAppConfig as IAppConfig;
}

export function useAppConfig(): [IAppConfig, boolean] {
  const [isLoading, setIsLoading] = useState(true);
  const [appConfigInternal, setAppConfigInternal] = useState<IAppConfig | undefined>(undefined);

  useEffect(() => {
    const configEndpointUrl = window.configEndpointUrl;
    if (!configEndpointUrl) {
      throw new Error("Config endpoint is not known. Cannot load configuration. Please set the configuration endpoint on 'window.configEndpointUrl'");
    }

    if (cachedAppConfig) {
      setAppConfigInternal(cachedAppConfig);
      setIsLoading(false);
    }

    setIsLoading(true);
    let url = window.configEndpointUrl;

    axios
      .get<IAppConfig>(url)
      .then((res) => {
        cachedAppConfig = res.data;
        appConfig = res.data;
        setAppConfigInternal(res.data);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return [appConfigInternal as IAppConfig, isLoading];
}
